var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestimonial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 0.00136727V79.9997C90 85.5226 85.5229 89.9997 80 89.9997H0.00136577C0.000455648 89.8333 0 89.6667 0 89.5C0 40.0705 40.0705 0 89.5 0C89.6668 0 89.8334 0.00045615 90 0.00136727Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0002 20.0011V80C90.0002 85.5229 85.5231 90 80.0002 90H20.0011C20.0004 89.8705 20 89.741 20 89.6113C20 51.166 51.166 20 89.6113 20C89.741 20 89.8707 20.0004 90.0002 20.0011Z",
    fill: "#FCB040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 40.0008V79.9998C90 85.5227 85.5228 89.9998 80 89.9998H40.0008C40.0003 89.9074 40 89.8148 40 89.7222C40 62.2614 62.2614 40 89.7222 40C89.8149 40 89.9075 40.0003 90 40.0008Z",
    fill: "#FFD18C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonial);
export default __webpack_public_path__ + "static/media/testimonial.aefeca2acd9031554395e10e25f84184.svg";
export { ForwardRef as ReactComponent };